var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStarFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0004 9C22.9004 8.6 22.6004 8.4 22.2004 8.3L15.8004 7.4L12.9004 1.6C12.7004 1.2 12.4004 1 12.0004 1C11.6004 1 11.3004 1.2 11.1004 1.6L8.20043 7.4L1.90043 8.3C1.50043 8.4 1.20043 8.6 1.00043 9C0.800428 9.4 1.00043 9.8 1.30043 10L5.90043 14.4L4.80043 20.8C4.70043 21.2 4.90043 21.6 5.20043 21.8C5.50043 22 5.90043 22.1 6.30043 21.9L12.0004 18.9L17.7004 21.9C17.9004 22 18.0004 22 18.2004 22C18.4004 22 18.6004 21.9 18.8004 21.8C19.1004 21.6 19.3004 21.2 19.2004 20.8L18.1004 14.4L22.7004 10C23.0004 9.8 23.1004 9.4 23.0004 9Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStarFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconStarFilled.e8ab7de2086d2f4778316e003f8e8ae9.svg";